// extracted by mini-css-extract-plugin
export var md = "_50-4";
export var semantic = "_50-5";
export var sm = "_50-3";
export var text = "_50-6";
export var toggleInput = "_50-0";
export var toggleSwitch = "_50-1";
export var xs = "_50-2";